"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GiftFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GiftFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.278 4.176c.174.32.406.598.68.824H1.25C.56 5 0 5.56 0 6.25V9c0 .182.049.353.134.5H7.5V5h1v4.5h7.366A.995.995 0 0 0 16 9V6.25C16 5.56 15.44 5 14.75 5h-1.707c.273-.226.505-.504.679-.824C14.749 2.294 13.369 0 11.225 0a2.849 2.849 0 0 0-2.763 2.15L8 4l-.462-1.85A2.849 2.849 0 0 0 4.775 0C2.63 0 1.252 2.294 2.278 4.176Zm2.314.465 2.596.236-.62-2.484A1.849 1.849 0 0 0 4.775 1C3.38 1 2.498 2.491 3.155 3.697c.292.535.831.889 1.437.944Zm6.816 0-2.596.236.62-2.484A1.849 1.849 0 0 1 11.225 1c1.395 0 2.277 1.491 1.62 2.697-.292.535-.831.889-1.437.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5H8.5V16h5a1.5 1.5 0 0 0 1.5-1.5v-4ZM7.5 10.5H1v4A1.5 1.5 0 0 0 2.5 16h5v-5.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GiftFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GiftFill;
exports["default"] = _default;